/* eslint-disable react-hooks/rules-of-hooks */

import { AD_UNIT_SECTION, AD_UNIT_SECTION_NEW } from './types';
import { PAGE_MAPPING, PAGE_MAPPING_NEW } from './constants';

// getPageSectionForAdUnit is used to find the section of website and return a valid advertising ad unit 'section'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPageSectionForAdUnit = (route: string): AD_UNIT_SECTION => {
    const page = Object.entries(PAGE_MAPPING).find((k) =>
        route.startsWith(k[0])
    );

    if (page === undefined) {
        return AD_UNIT_SECTION.UNKNOWN;
    }

    return page[1] as AD_UNIT_SECTION;
};

// getPageSectionForAdUnit is used to find the section of website and return a valid advertising ad unit 'section'
// this is for new taxonomy mapping
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPageSectionForAdUnitNew = (
    route: string
): AD_UNIT_SECTION_NEW => {
    const page = Object.entries(PAGE_MAPPING_NEW).find((k) =>
        route.startsWith(k[0])
    );

    if (page === undefined) {
        return AD_UNIT_SECTION_NEW.UNKNOWN;
    }

    return page[1] as AD_UNIT_SECTION_NEW;
};
